import React, { useEffect, useState, useRef, useContext } from 'react';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, PrintDocument, formatDateMMDDYYYY } from "../../GlobalScript";
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import Cookies from 'js-cookie';
import ReactPaginate from 'react-paginate';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import HistoryDetail from '../HistoryDetail';
import FooterDealer from '../../FooterDealer.js';
import { ShoppingCartContext } from '../ShoppingCartContext';

export default function CreditHistory() {

    const countPerPage = 25;
    const [pageResults, setPageResults] = useState(countPerPage);
    const [tempPage, setTempPage] = useState(countPerPage);
    const [resultsLength, setResultsLength] = useState(0);
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [dateFrom, setDateFrom] = useState(formatDateMMDDYYYY(new Date(new Date().setMonth(new Date().getMonth() - 1))));
    const [dateTo, setDateTo] = useState(formatDateMMDDYYYY(new Date()));
    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + pageResults;
    const currentItems = orderItems.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(orderItems.length / pageResults);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [StatusList, setStatusList] = useState(null);
    const [pop, setPop] = useState(false);
    const historyType = 'credit';
    const location = useLocation();
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false); 
 
    const handleDetailsModalShow = async (order) => {
        //setSelectedOrder(order);
        await GetRequestDetail(order);
        setShowDetailsModal(true);
    }

    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
        setSelectedOrder(null);
    }

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            setKeyword(location.state.id);
        }
    }, [location])

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            LoadtatusList('', false);
        }
    }, [keyword])

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '' && orderItems && orderItems.length > 0) {
            handleDetailsModalShow(orderItems[0])
        }
    }, [orderItems])
   
    const GetRequestDetail = async (order) => {
        const response = await fetch("kdealer/GetCreditRequestDetail/" + order.orderID);
        if (response.status !== 200) {
            return;
        }
        const res = await response.json();

        const orderToShow = {
            order: order,
            orderDetail: res
        }
        setSelectedOrder(orderToShow);
    }

    useEffect(() => {
        if (loading) {
            GetListItems('', false);
            setLoading(false);
        }
    }, [loading]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'status') {
            setStatus(value);
        } else if (name === 'dateFrom') {
            setDateFrom(value);
        } else if (name === 'dateTo') {
            setDateTo(value);
        } else if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const ResetSearch = async () => {
        setKeyword('');
        setStatus('');
        setDateFrom('');
        setDateTo('');
        setLoading(true);
    }

    useEffect(() => {
        if (!StatusList) {
            LoadtatusList();
        }
    }, [StatusList]);

    const LoadtatusList = async () => {
        try {
            CheckSession();
            const response = await fetch("kdealer/GetCRStatusList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setStatusList(lst);

        } catch (e) {
            console.log(e);
            return;
        }
    }

    const handleSearchClick = async () => {
        try {
            GetListItems('', false);
        } catch (e) {
            console.log(e);
        }
    };

    const handleButtonClick = (orderNumber) => {
        setActiveRow(prevRow => (prevRow === orderNumber ? null : orderNumber));
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('button')) {
            setActiveRow(null);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * pageResults) % orderItems.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            setPageResults(tempPage);
        }
    }

    const GetListItems = async (orderby, inc) => {
        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const data = {
                keyword: keyword,
                status: status,
                dateFrom: dateFrom,
                dateTo: dateTo,
                orderBy: orderby,
                inc: false,
                dealerId: user.dealerID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetCreditRequestHistory", requestOptions);
            if (response.status !== 200) {
                handleClosePop();
                return;
            } else {
                debugger;
                const rec = await response.json();
                setOrderItems(rec);
                console.log(rec)
                setResultsLength(rec.length);
                handleClosePop();
            }
        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }
    //end

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));     
        document.title = 'K-Dealer - Credit Request History';
    }, []);

    const handlePrint = (crNum) => {
        if (crNum) {
            PrintDocument(crNum);
        }
    }
    
    return (
        <>
            <Container className="checkout-container main-container dealer-section">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">CREDIT REQUEST HISTORY</h1>
                    </Col>
                    <Col className="checkout-title-under">
                        {/*<Row className="excel-row">*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Credit Request</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Credit Request Items</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <FloatingLabel label="Keyword" className="mb-4">
                                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Order Status" className="mb-4">
                                            <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">
                                                <option value={''}>All</option>
                                                {
                                                    StatusList && StatusList.map((item, index) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Date From" className="mb-4">
                                            <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFrom} className={'form-control'} onChange={handleChange} name="dateFrom" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Date To" className="mb-4">
                                            <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateTo} className={'form-control'} onChange={handleChange} name="dateTo" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={{ offset: 8 }} className="text-right" style={{ alignSelf: 'center' }}>
                                        <p className="clickable underline green-text" onClick={ResetSearch}>Reset Search</p>
                                    </Col>
                                    <Col className="text-center mb-3">
                                        <Button variant="secondary" className="" onClick={handleSearchClick}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SEARCH
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-5 mb-4">
                    <Col sm={12}>
                        <Card className="">
                            <Card.Body>
                                <Row className="table-legend text-center">
                                    <Col sm={12}>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Submitted</span>
                                            <span className="icons-row"><div className={`status-icon blue-icon`}></div> Completed</span>
                                            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="pagination-row">
                                    <Col sm={12}>
                                        <p>
                                            <span className="bold">{resultsLength > 0 && resultsLength}</span> results | View
                                            <div className="paginate-results">
                                                <input name="tempPage" type="text" value={tempPage} onChange={handleChange} className="form-control" />
                                                <button className="btn btn-black btn-pagenav" onClick={changePageResults}>Go</button>
                                            </div>
                                        </p>

                                        <ReactPaginate
                                            breakLabel="..."
                                            nextLabel="next >"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={pageCount}
                                            previousLabel="< previous"
                                            renderOnZeroPageCount={null}
                                            containerClassName="table-navigation"
                                            previousLinkClassName="table-nav-link"
                                            nextLinkClassName="table-nav-link"
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12} className={currentItems.length > 2 ? "order-table" : "order-table no-scroll-lg"}>
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>CREDIT REQUEST #</th>
                                                    <th>REQUEST DATE</th>
                                                    <th>REQUESTED BY</th>
                                                    <th>STATUS</th>
                                                    <th>KMC INVOICE</th>
                                                    <th>TOTAL</th>
                                                    <th width="10%"></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>    
                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr className="" key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.orderID}</td>
                                                        <td>{item.orderDate}</td>
                                                        <td className="text-left">{item.orderBy} <br /> {item.orderByName}</td>
                                                        <td className="table-img"><span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>
                                                        <td>{item.invoice}</td>
                                                        <td>${item.total}</td>
                                                        <td>
                                                            <Button variant="primary" onClick={() => handleDetailsModalShow(item)}>
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                VIEW
                                                            </Button>
                                                        </td>
                                                        <td ref={dropdownRef} style={{ position: activeRow === item.orderID ? 'absolute' : 'static' }}>
                                                            <DropdownButton
                                                                variant="outline-dark"
                                                                title="Actions"
                                                                id="input-group-dropdown-1"
                                                            >
                                                                <Dropdown.Item onClick={() => handlePrint(item.orderID)} >Print Return Documents</Dropdown.Item>
                                                                <Dropdown.Item>Request Call Tag</Dropdown.Item>
                                                            </DropdownButton>
                                                        </td>
                                                    </tr>
                                                )) }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <HistoryDetail show={showDetailsModal} handleClose={handleDetailsModalClose} order={selectedOrder} historyType={historyType} />
        </>
    );
}